import React from 'react';
import '../less/greenPolicy.less';
import FAQStorybook from '@abank/abank-faq';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import hero_img from '../img/hero_img.png';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import additionalCards from '../enums/additional_cards_data.json';
import insurerInfoDataConfig from '../enums/insurer_info_data.json';
import intermediaryTariffsData from '../enums/intermediary_tariffs_data.json';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import { insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoVusoLink,insuranceIntermediaryInfoUniversalnaLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoEiaLink,insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoTaslifeLink, insuranceDocumentsVusoCompanyLink, insuranceGreenPolicyDocumentsVusoProductLink, insuranceDocumentsIngoCompanyLink, insuranceGreenPolicyDocumentsIngoProductLink, insuranceDocumentsTasCompanyLink, insuranceGreenPolicyDocumentsTasProductLink, insuranceDocumentsOrantaCompanyLink, insuranceGreenPolicyDocumentsOrantaProductLink, insuranceDocumentsPzuCompanyLink, insuranceGreenPolicyDocumentsPzuProductLink, insuranceDocumentsUticoCompanyLink, insuranceGreenPolicyDocumentsUticoProductLink } from '../../../services/urls/urls';
import { Preloader } from 'MWComponents';
import intermediaryInfoDataConfig from '../enums/intermediary_info_data.json';
import InsuranceIntermediaryInfo from '../../../auxiliary-components/shared/InsuranceIntermediaryInfo';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import QuestionsFullAdmin from '../../../auxiliary-components/shared/QuestionsFullAdmin';
import InfoBlock from '../../../auxiliary-components/shared/InfoBlock/index';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import { mapInsuranceDetailedInfoToTariffs } from './../../../helpers/utils/mapInsuranceDetailedInfoToTariffs';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import { canUseDOM } from '../../../helpers/canUseDOM';

export default function template() {
  const page = "green-policy-new";

  const tabs = [{tab: 'insurer-info', title: 'SERVICES_GREEN_POLICY_NEW_TABS_TITLE_01'},
        {tab: 'partners', title: 'SERVICES_GREEN_POLICY_NEW_TABS_TITLE_02'},
        {tab: 'insurance-info', title: 'SERVICES_GREEN_POLICY_NEW_TABS_TITLE_03'},
        {tab: 'intermediary-info', title: 'SERVICES_GREEN_POLICY_NEW_TABS_TITLE_04'}];

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3
  };

  const linksMap = { insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoVusoLink,insuranceIntermediaryInfoUniversalnaLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoEiaLink,insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoTaslifeLink, insuranceDocumentsVusoCompanyLink, insuranceGreenPolicyDocumentsVusoProductLink, insuranceDocumentsIngoCompanyLink, insuranceGreenPolicyDocumentsIngoProductLink, insuranceDocumentsTasCompanyLink, insuranceGreenPolicyDocumentsTasProductLink, insuranceDocumentsOrantaCompanyLink, insuranceGreenPolicyDocumentsOrantaProductLink, insuranceDocumentsPzuCompanyLink, insuranceGreenPolicyDocumentsPzuProductLink, insuranceDocumentsUticoCompanyLink, insuranceGreenPolicyDocumentsUticoProductLink };

  const intermediaryInfoData = intermediaryInfoDataConfig.map(item => {
    if (item.type === 'companies' && item.companies) {
      return {
        ...item,
        companies: item.companies.map(company => ({
          ...company,
          link: linksMap[company.link]
        }))
      };
    }
    
    return {
      ...item
    };
  });

  const insurerInfoData = insurerInfoDataConfig.map(item => ({
    ...item,
    values: item.values.map(val => {
      if (val.type === 'button') {
        return {
          ...val,
          btnLink: linksMap[val.btnLink],
        };
      }

      return val;
    }),
  }));

  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const hero_data = {
    title: "SERVICES_GREEN_POLICY_NEW_HERO_TITLE",
    text: "SERVICES_GREEN_POLICY_NEW_HERO_TEXT"
  }

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');
  
  const detailedInfoWidget = this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoWidget', 'questions');

  const detailedInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(detailedInfoWidget);

  return (
    <div className="green-policy-new">
      <Hero
        data={hero_data}
        img={hero_img}
    />
        <div className={`content${(this.state.faqTab || this.state.detailedInsuranceInfoTab || this.state.intermediaryInsuranceInfoTab) ? ' hidden' : ''}`}>
            <div className="general-info">
              <div className="container">
                <h2 className="general-info__title">{this.l10n('SERVICES_GREEN_POLICY_NEW_GENERAL_INFO_TITLE')}</h2>
                <div className="general-info__text">
                  <p>{this.l10n('SERVICES_GREEN_POLICY_NEW_GENERAL_INFO_TEXT_01')}</p>
                  <p>{this.l10n('SERVICES_GREEN_POLICY_NEW_GENERAL_INFO_TEXT_02')}</p>
                  <p>{this.l10n('SERVICES_GREEN_POLICY_NEW_GENERAL_INFO_TEXT_03')}</p>
                </div>
              </div>
            </div>
            <Advantages
              items={advantagesItems}
              title={'SERVICES_GREEN_POLICY_NEW_ADVANTAGES_TITLE'}
            />
            <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
              <Tariffs
                items={insurerInfoData}
                title={'SERVICES_GREEN_POLICY_TARIFFS_INSURER_INFO_TITLE'}
                insurerInfo
                titleTag={"div"}
              />
              {this.state.loader ? (canUseDOM ? <Preloader/> : null) : (partnersWidget && partnersWidget.data && partnersWidget.data.length > 0 ? (
                <div className="partners">
                  <div className="container">
                    <div className="partners__body">
                    {partnersWidget.data.sort((a, b) => a.order - b.order).map((item, index) => (
                      <div className="partners__item" key={index}>
                        <img className="partners__image" src={item.img_desktop} alt="partners image"/>
                      </div>
                    ))}
                    </div>
                  </div>
                </div>
              ) : null)}
              {this.state.detailedInfoWidget_loading ? (canUseDOM ? <Preloader/> : null) : (detailedInfoTariffsItems && detailedInfoTariffsItems.length > 0 ? (
                <Tariffs
                  items={detailedInfoTariffsItems}
                  alignItems="start"
                  onBtnClick={this.toggleDetailedInsuranceInfoTab}
                  btnText={'SERVICES_GREEN_POLICY_NEW_TARIFFS_INSURANCE_INFO_BTN'}
                  insuranceInfo
                />
              ) : null)}
              <Tariffs
                items={intermediaryTariffsData}
                title={'SERVICES_GREEN_POLICY_NEW_TARIFFS_INTERMEDIARY_INFO_TITLE'}
                alignItems="start"
                onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
                btnText={'SERVICES_GREEN_POLICY_NEW_TARIFFS_INTERMEDIARY_INFO_BTN'}
              />
            </Tabs>
            <AdditionalProduct
              items={additionalCards}
              title={'SERVICES_GREEN_POLICY_NEW_ADDITIONAL_PRODUCT_TITLE'}
            />
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'SERVICES_GREEN_POLICY_NEW_QUESTIONS_TITLE'}
              loader={this.state.loader}
            />
        </div>
        <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
          <FAQStorybook
            widget={questionsWidget}
            title={this.l10n('SERVICES_GREEN_POLICY_NEW_FAQ_STORYBOOK_TITLE')}
            btnText={this.l10n('SERVICES_GREEN_POLICY_NEW_FAQ_STORYBOOK_BTN_TEXT')}
            onBtnClick={this.toggleFaqTab}
            filterByEnvironment={filterByEnvironment}
          />
        </div>
        <div className={`content${!this.state.detailedInsuranceInfoTab ? ' hidden' : ''}`}>
          <QuestionsFullAdmin
            widget={detailedInfoWidget}
            title={'SERVICES_GREEN_POLICY_NEW_DETAILED_INFO_TITLE'}
            toggleFaqTab={this.toggleDetailedInsuranceInfoTab}
          />
        </div>
        <div className={`content${!this.state.intermediaryInsuranceInfoTab ? ' hidden' : ''}`}>
          <InsuranceIntermediaryInfo
            items={intermediaryInfoData}
            title={'SERVICES_GREEN_POLICY_NEW_INTERMEDIARY_INFO_TITLE'}
            onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
            btnText={'SERVICES_GREEN_POLICY_NEW_INTERMEDIARY_INFO_BTN'}
          />
        </div>
    </div>
  )
}
